module.exports = __webpack_public_path__ + "img/pr-5.76640734.png";